import React, { ReactNode, useCallback, useRef } from 'react'

export interface ScrollToViewContainerProps {
	timeout?: number
	children: ReactNode
}

export const ScrollToViewContainer = ({
	timeout = 0,
	children,
}: ScrollToViewContainerProps) => {
	const ref = useRef<HTMLDivElement | null>(null)

	const handleOnClick = useCallback((event) => {
		if (event.target.tagName === 'LABEL' || event.target.tagName === 'INPUT') {
			setTimeout(
				() => ref.current?.scrollIntoView({ behavior: 'smooth' }),
				timeout,
				event,
				0,
			)
		}
	}, [])

	return (
		<div id="scrollToViewContainer" ref={ref} onClick={handleOnClick}>
			{children}
		</div>
	)
}
